<div [innerHTML]="style"></div>

<div class="wrapper" [class.responsible]="responsible">
  <div class="oneroll-player-password-wrapper" id="player-root" *ngIf="isNeedPassword">
    <app-password [playlist]="playlist" [image]="imagePassword" (reloadPlaylist)="reloadPlaylist()"></app-password>
  </div>

  <div class="oneroll-player-playlist-wrapper" id="player-root" *ngIf="playlist && ! isNeedPassword && ! lpEnable">
    <ng-container *ngTemplateOutlet="playlistTemplate"></ng-container>
  </div>  

  <div class="oneroll-player-playlist-wrapper" id="player-root" *ngIf="playlist && ! isNeedPassword && lpEnable">

    <div class="oneroll-player-lp-wrapper" *ngIf="! isNeedPassword">
      <div class="video-player-lp">
        <div class="vpl-logo" *ngIf="getMainContentVideo()?.userVideo.lp?.data?.logo?.url">
          <img [src]="getMainContentVideo()?.userVideo.lp.data.logo.url">
        </div>
        <div class="vpl-player">
          <div class="video-wrapper">
            <div class="vpl-video-wrapper">
              <div class="vpl-video-container">
                <ng-container *ngTemplateOutlet="playlistTemplate"></ng-container>
              </div>
            </div>
          </div>
        </div>
        <div class="vpl-title">{{getMainContentVideo()?.userVideo.lp.data?.title}}</div>
        <div class="vpl-description" [innerHTML]="getMainContentVideo()?.userVideo.lp.data?.description | safeHtml"></div>
      </div>
    </div>
  </div>
</div>

<ng-template #playlistTemplate>
  <div class="sub-contents-wrapper" [class.show]="isShowSubContents">

    <div class="sub-contents-progress-wrapper">
      <div *ngIf="currentContentListSubContentsCount !== false" class="progress" [style.width]="getProgressWidth()"></div>
    </div>

    <div class="sub-contents">
      <mat-horizontal-stepper class="stepper-wrapper" #subContentsStepper [@.disabled] = "true">

        <ng-container *ngIf="currentSubContents">
          <mat-step *ngFor="let subContent of currentSubContents">

            <!-- <ng-container *ngIf="['Recommend'].includes(content.type)">
              <app-recommend class="recommend" [recommend]="subContent" (recommendChecked)="recommendChecked($event)"></app-recommend>
            </ng-container>

            <ng-container *ngIf="['Statistics'].includes(content.type)">
              <app-statistics class="statistics" [statistics]="subContent" (statisticsChecked)="statisticsChecked($event)"></app-statistics>
            </ng-container> -->

            <ng-container *ngIf="subContent.type == 'CtaSimple'">
              <app-cta-simple class="cta-simple" [ctaSimple]="subContent" (backToTop)="backToTop()" (ctaSimpleCtaClicked)="ctaSimpleCtaClicked($event)" (ctaSimpleforwardClicked)="ctaSimpleforwardClicked($event)"></app-cta-simple>
            </ng-container>

            <ng-container *ngIf="subContent.type == 'MessageSimple'">
              <app-message-simple class="message-simple" [messageSimple]="subContent" (backToTop)="backToTop()" (messageSimpleforwardClicked)="messageSimpleforwardClicked($event)" (linkClick)="messageSimpleLinkClick($event)"></app-message-simple>
            </ng-container>

            <ng-container *ngIf="subContent.type == 'FormOverlay'">
              <app-form-overlay class="form-overlay" [formOverlay]="subContent" (backToTop)="backToTop()" (formOverlayInputed)="formOverlayInputed($event)"></app-form-overlay>
            </ng-container>

            <ng-container *ngIf="subContent.type == 'QuestionSelect' || subContent.type == 'QuestionText' || subContent.type == 'QuestionRating'">
              <app-question class="question" [question]="subContent" [hasBack]="!!(subContentsStepper.selectedIndex > 0)" (backToTop)="backToTop()" (backToPrev)="backToPrev()" (questionInputed)="questionInputed($event)" (questionSkipped)="questionSkipped($event)"></app-question>
            </ng-container>

          </mat-step>
        </ng-container>
      </mat-horizontal-stepper>
    </div>
  </div>

  <div class="main-contents-wrapper">
    <mat-horizontal-stepper *ngIf="currentMainContents" class="stepper-wrapper" #mainContentsStepper [@.disabled] = "true">
      <mat-step *ngFor="let mainContent of currentMainContents">
        <div class="main-content-wrapper">
          <ng-container *ngIf="mainContent.type == 'Video'">
            <app-player #playerComponents class="main-content player" [playlist]="playlist" [video]="mainContent" (playerTriggered)="playerTriggered($event)" (formExpandInputed)="formExpandInputed($event)"></app-player>
          </ng-container>
          <ng-container *ngIf="mainContent.type == 'CtaSimple'">
            <app-cta-simple class="main-content cta-simple" [ctaSimple]="mainContent" (backToTop)="backToTop()" (ctaSimpleforwardClicked)="ctaSimpleforwardClicked($event)"></app-cta-simple>
          </ng-container>

          <ng-container *ngIf="mainContent.type == 'MessageSimple'">
            <app-message-simple class="main-content message-simple" [messageSimple]="mainContent" (backToTop)="backToTop()" (messageSimpleforwardClicked)="messageSimpleforwardClicked($event)" (linkClick)="messageSimpleLinkClick($event)"></app-message-simple>
          </ng-container>

          <ng-container *ngIf="mainContent.type == 'QuestionSelect' || mainContent.type == 'QuestionText' || mainContent.type == 'QuestionRating'">
            <app-question class="main-content question" [question]="mainContent" (backToTop)="backToTop()" (questionInputed)="questionInputed($event)" (questionSkipped)="questionSkipped($event)"></app-question>
          </ng-container>
        </div>

      </mat-step>
    </mat-horizontal-stepper>
  </div>
</ng-template>